import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { Shell } from '@/components/layout/Shell'
import { AuthGuard } from '@/components/auth/AuthGuard'
import { Login } from '@/pages/Login'
import { MagicLinkLanding } from '@/pages/MagicLinkLanding'
import { QuotationsListPage } from '@/routes/quotations/QuotationsListPage'
import { NewQuotationPage } from '@/routes/quotations/NewQuotationPage'
import { QuotationDetailPage } from '@/routes/quotations/QuotationDetailPage'
import { ClientsListPage } from '@/routes/clients/ClientsListPage'
import { ClientDetailPage } from '@/routes/clients/ClientDetailPage'
import { ResellersListPage } from '@/routes/resellers/ResellersListPage'
import { ResellerDetailPage, FreelancerDetailPage } from '@/routes/resellers/ResellerDetailPage'
import { ConfigPage } from '@/routes/config/ConfigPage'
import { CommissionsPage } from '@/routes/commissions/CommissionsPage'
import { DashboardPage } from '@/routes/dashboard/DashboardPage'
import { MediaLibraryPage } from '@/routes/cms/MediaLibraryPage'
import { GlobalsListPage } from '@/routes/cms/GlobalsListPage'
import { GlobalEditorPage } from '@/routes/cms/GlobalEditorPage'
import { UsersPage } from '@/routes/users/UsersPage'

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <h1 className="text-4xl font-bold text-gray-900">404</h1>
      <p className="mt-2 text-gray-600">Page not found</p>
    </div>
  )
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes — no Shell, no AuthGuard */}
      <Route path="/login" element={<Login />} />
      <Route path="/magic-link" element={<MagicLinkLanding />} />

      {/* Protected routes — wrapped in AuthGuard + Shell */}
      <Route
        element={
          <AuthGuard>
            <Shell>
              <Outlet />
            </Shell>
          </AuthGuard>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />

        {/* Quotations — static route /new before dynamic /:id */}
        <Route path="/quotations" element={<QuotationsListPage />} />
        <Route path="/quotations/new" element={<NewQuotationPage />} />
        <Route path="/quotations/:id" element={<QuotationDetailPage />} />

        {/* Clients — static /clients before dynamic /clients/:id */}
        <Route path="/clients" element={<ClientsListPage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />

        {/* Channel partners — Resellers + Freelancers (Phase 17) */}
        {/* /resellers hosts both tabs; detail routes use separate paths */}
        <Route path="/resellers" element={<ResellersListPage />} />
        <Route path="/resellers/:id" element={<ResellerDetailPage />} />
        <Route path="/freelancers/:id" element={<FreelancerDetailPage />} />

        {/* Config — super_admin system configuration (Phase 17-06) */}
        <Route path="/config" element={<ConfigPage />} />

        {/* Commissions — rules CRUD and entry ledger (Phase 17-04) */}
        <Route path="/commissions" element={<CommissionsPage />} />

        {/* CMS — media library and global content management (Phase 18) */}
        <Route path="/cms/media" element={<MediaLibraryPage />} />
        {/* CMS Globals — static /cms/globals before dynamic /cms/globals/:slug */}
        <Route path="/cms/globals" element={<GlobalsListPage />} />
        <Route path="/cms/globals/:slug" element={<GlobalEditorPage />} />

        {/* Users — super_admin user management */}
        <Route path="/users" element={<UsersPage />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
